import type { ErrorWithLabelMessage } from '@/context/services/admin_invoice_reports/AdminInvoiceReportsQuery.enums';
import { useMemo } from 'react';

export type UseInfoTagCellProps = {
  errorMessages?: ErrorWithLabelMessage[];
  messageType: string[];
};

export const useInfoTagCell = ({
  errorMessages,
  messageType,
}: UseInfoTagCellProps) => {
  const filteredMessages = useMemo(() => {
    return (
      errorMessages?.filter((msg) =>
        messageType.includes(msg.message_type || '')
      ) || []
    );
  }, [errorMessages, messageType]);

  return {
    filteredMessages,
  };
};
